
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'preview-file-dialog',
    templateUrl: './preview-file-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule]
})
export class PreviewFileDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            file: any;
        },
        public dialogRef: MatDialogRef<PreviewFileDialogComponent>    ) { }

    closeDialog(result?: any) {
        this.dialogRef.close(result);
    }

}
